export default __webpack_public_path__ + "locales/sr-Cyrl-RS/EmptyView.json?hash=e42012f449b2da13ff60a687f9a33027";